import LayoutA from './LayoutA';
import LayoutB from './LayoutB';
import LayoutC from './LayoutC';
import "./index.scss";

export default { LayoutA, LayoutB, LayoutC};